<template>
  <div class="group-info x-margin x-border-50">
    <my-head-title
      :title="$t('HT.accessInfo.title')"
      :showEdit="$hasModule(10)"
      @edit="showInfo"
    ></my-head-title>
    <div class="x-padding">
      <my-info-item :title="$t('HT.apiList.group')" :info="formData.name"></my-info-item>
      <my-info-item :title="$t('HT.apiStepOne.remark')" :info="formData.remark"></my-info-item>
      <my-info-item
        :title="$t('HT.groupInfo.secondDomain')"
        :info="formData.second_domain && formData.second_domain.domain"
      ></my-info-item>
      <div>
        <ux-searchOption :layout="layout2" @bindDomain="bindDomain(formData)"></ux-searchOption>
        <ux-table
          ref="table"
          :showPage="false"
          :data="appList"
          :emptyText="$t('HT.nodata')"
          :columns="columns2"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
    </div>
  </div>
</template>

<script>
import certiFicate from './template/certiFicate';
import envShow from './template/envShow';
import editEnv from './template/editEnv';
import groupDeital from './template/groupDeital';
import domain from './template/domain';
export default {
  components: {
    certiFicate,
    envShow,
    editEnv,
    groupDeital,
    domain
  },
  data() {
    return {
      id: this.$route.query.id, // 详情id
      formData: {}, /// 详情页面的数据
      appList: [], // 已绑定应用列表
      layout2: [
        // 搜索项配置
        {
          type: 'button',
          left: true,
          text: this.$t('HT.groupInfo.secondDomain'),
          show: true,
          event: 'bindDomain',
          hidden: !this.$hasModule(10)
        }
      ],
      columns2: [
        {
          // 表格项
          label: this.$t('HT.debug3.domain'),
          prop: 'domain',
          tooltip: true
        },
        {
          label: this.$t('HT.addAccessApi.evn'),
          tooltip: true,
          render: (h, params) => {
            return h(envShow, {
              props: {
                list: params.envs || []
              }
            });
          }
        },
        {
          label: this.$t('HT.groupInfo.sslOperate'),
          hidden: !this.$hasModule(10),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: params.file_name
                  ? [this.$t('HT.groupInfo.sslOperateEdit')]
                  : [this.$t('HT.groupInfo.sslOperateChoose')],
                colors: ['#0087ff'],
                event: ['choose']
              },
              on: {
                choose: () => {
                  this.showChoose(params);
                }
              }
            });
          }
        },
        {
          label: this.$t('HT.groupInfo.ssl'),
          hidden: false,
          render: (h, params) => {
            return h('span', {}, params.file_name ? params.file_name : '');
          }
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(10),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.groupInfo.del'), this.$t('HT.groupInfo.change')],
                colors: ['#0087ff'],
                event: ['del', 'changeEnv']
              },
              on: {
                del: () => {
                  const title = this.$t('HT.groupInfo.del');
                  const content = this.$t('HT.groupInfo.del.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params);
                    }
                  });
                },
                changeEnv: () => {
                  this.showEdit(params);
                }
              }
            });
          }
        }
      ]
    };
  },
  created() {
    this.getInfo(this.id);
  },

  methods: {
    /**
     * @description: 获取详情列表数据
     * @param {Number} id 分组id
     */
    getInfo(id) {
      this.$api.group.getInfo(id).then((res) => {
        let list = res.data.domains;
        this.appList = res.data.domains;
        let array = [];
        for (let i = 0; i < list.length; i++) {
          let r = list[i]['domain'].split(';');
          array = array.concat(r);
        }
        this.formData = res.data;
      });
    },

    /**
     * 绑定域名弹窗
     * @param {Object} params 单行表格数据
     */
    bindDomain(params) {
      const title = this.$t('HT.groupInfo.bindDomain');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(domain, {
            props: { data: params },
            on: {}
          });
        },
        confirm: (params) => {
          this.domain(params);
        }
      });
    },
    /**
     * 域名绑定
     * @param {Object} params 表单提交参数
     */
    domain(params) {
      this.$uxLoading.show();
      this.$api.group.domain(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
          // this.getList(this.filter);
          this.getInfo(this.id);
        }
      });
    },
    /**
     * 编辑分组
     */
    showInfo() {
      const title = this.$t('HT.groupInfo.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(groupDeital, {
            props: { data: this.formData },
            on: {}
          });
        },
        confirm: (data) => {
          this.putInfoList(data);
        }
      });
    },

    /**
     * 修改列表
     * @param {Number} id 唯一标识
     * @param {Object} params 表单提交参数
     */
    putInfoList(params) {
      this.$uxLoading.show();
      this.$api.group.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getInfo(this.id);
        }
      });
    },

    /**
     * 更换环境
     */
    showEdit(params) {
      const title = this.$t('HT.groupInfo.change');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(editEnv, {
            props: { data: params, data1: this.formData },
            on: {}
          });
        },
        confirm: (data) => {
          this.putEnvList(data);
        }
      });
    },

    /**
     * 修改环境
     * @param {Number} id
     * @param {Object} params 表单提交参数
     */
    putEnvList(params) {
      this.$uxLoading.show();
      this.$api.group.putEnv(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getInfo(this.id);
        }
      });
    },

    /**
     * 修改列表
     * @param {Number} id 唯一标识
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.group.domain(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getInfo(this.id);
        }
      });
    },

    /**
     * @description: 上传证书
     * @param {Object} params 表的数据
     */
    showChoose(params) {
      const title = this.$t('HT.groupInfo.upload');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(certiFicate, {
            props: { data: params },
            on: {}
          });
        },
        confirm: (data) => {
          let list = new FormData();
          list.append('certificate', data.certificate);
          list.append('domain', data.domain);
          list.append('password', data.password);
          this.$api.group.certificate(list).then((res) => {
            if (res.code === 10000) {
              // 刷新表的数据
              this.getInfo(this.id);
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.uploadCertificateSuccess'));
            }
          });
        }
      });
    },

    /**
     * 删除列表
     * @param {String} 唯一标识
     */
    delList(params) {
      this.$api.group
        .delDomain({
          id: this.id,
          domain_id: params.id
        })
        .then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            this.getInfo(this.id);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
